const DEFAULT_PROJECTS = [
  {
    id: "veentto-vagos",
    slug: "veentto-vagos",
    title: "Veentto Vagos",
    client: "Veentto Vagos",
    cat: "Site",
    tags: ["Eventos", "Booking", "Vagos"],
    img: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1200&h=900&fit=crop&q=82&auto=format",
    url: "https://www.veenttovagos.com",
    description: "Site de eventos e booking para experiências em Vagos.",
    context: "Projeto para uma marca de eventos em Vagos que precisava de uma presença digital simples, direta e fácil de partilhar.",
    problem: "A presença digital dos eventos dependia de canais dispersos e não havia uma base própria para apresentar programação, contactos e próximas iniciativas.",
    objective: "Criar um website claro para divulgar eventos, centralizar informação e dar mais credibilidade a quem procura experiências em Vagos.",
    solution: "Website responsivo com estrutura visual forte, navegação simples, área para eventos e chamada direta para contacto/booking.",
    technologies: ["React", "Design responsivo", "SEO técnico", "Performance web"],
    functionalities: ["Divulgação de eventos", "Contacto rápido", "Estrutura preparada para SEO", "Experiência mobile"],
    result: "A Veentto passou a ter uma base digital própria para apresentar eventos e encaminhar interessados para contacto sem depender apenas de redes sociais.",
    metrics: [],
    casePath: "/projetos/veentto-vagos",
  },
];

module.exports = {
  DEFAULT_PROJECTS,
};
